export const DISTRICT_REPORT_SET_PICKUP_LOCATION_ID = 'DISTRICT_REPORT_SET_PICKUP_LOCATION_ID';
export const DISTRICT_REPORT_SET_SITE_ID = 'DISTRICT_REPORT_SET_SITE_ID';
export const DISTRICT_REPORT_SET_REPORT = 'DISTRICT_REPORT_SET_REPORT';
export const DISTRICT_REPORT_SET_REPORT_STUDENTS = 'DISTRICT_REPORT_SET_REPORT_STUDENTS';
export const DISTRICT_REPORT_PATCH_ORDER_ITEMS = 'DISTRICT_REPORT_PATCH_ORDER_ITEMS';
export const DISTRICT_REPORT_SET_REPORT_MENU_TYPE_ID = 'DISTRICT_REPORT_SET_REPORT_MENU_TYPE_ID';
export const DISTRICT_REPORT_CHANGE_BULK_ORDER_QUANTITY = 'DISTRICT_REPORT_CHANGE_BULK_ORDER_QUANTITY';
export const DISTRICT_REPORT_SET_PRINT_LABEL_SCOPE_PARAMETERS = 'DISTRICT_REPORT_SET_PRINT_LABEL_SCOPE_PARAMETERS';
